export enum localStorageConsts {
  language = 'lang',
  rememberMe = 'auth_remember_me',
}
